import Token from '@/utils/Token';

export default {
    side(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/menu/side${params}`, Token.getHeader());
    },
}
